import Swal from 'sweetalert2';
import history from '#/history';

export const sagaSuccess = (message = '', path) => function* () {
    yield Swal.fire('Success!', message, 'success');
    if (path) yield history.push(path);
};

export const sagaFail = (message = '', path) => function* () {
    yield Swal.fire('Oops something went wrong...', message, 'error');
    if (path) yield history.push(path);
};

